import * as msgpack from '@mta/msgpack-js-lib';

export default class B2bUser {
	constructor(
			/** AbstractUser= */ user = null,
			/** !boolean= */ hasMinimalRight = false
	) {
		/** @member {AbstractUser} */
		this.user = user;
		/** @member {!boolean} */
		this.hasMinimalRight = hasMinimalRight;
	}

	/**
	 * @param {!object} os
	 * @param {!function} genericTypePackers
	 * @param {Number} __uid__
	 * @return {object}
	 */
	pack(os, genericTypePackers, __uid__) {
		return {
			__uid__: __uid__,
			user: os.writeObject(this.user),
			hasMinimalRight: os.writeBoolean(this.hasMinimalRight)
		};
	}

	/**
	 * @param {!object} is
	 * @param {B2bUser} value
	 */
	unpack(is, value) {
		if (value.user !== undefined)
			this.user = is.readObject(value.user, () => new msgpack.gen.com.ge.sdc.common.user.bean.AbstractUser());
		if (value.hasMinimalRight !== undefined)
			this.hasMinimalRight = is.readBoolean(value.hasMinimalRight);
	}
}

msgpack.registerClass('com.arabellesolutions.sdc.b2b.common.user.B2bUser', B2bUser);
